module.exports = __webpack_public_path__ + "img/multi-two-group-paired.3690478c.svg";